/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Publish_Review_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Publish completed, but the review request failed: {error}" |
*
* @param {Iconik_Publish_Review_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_review_failed_toast = /** @type {((inputs: Iconik_Publish_Review_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Review_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Publish completed, but the review request failed: ${i?.error}`)
});